// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
import env from "./.env";

export const environment = {
  production: false,
  development: true,
  version: env.npm_package_version + "-dev",
  
  // BASE_URL: 'https://fed.portal.zappyhire.com/pt/',
  captcha_site_key: "6Lf-MjEaAAAAAFnQ9-hMlk7Q-kcVIaFRhnQTn5Lf",
  // BASE_URL: 'https://dev.zappyhire.com/demo/',
  BASE_URL: "https://fed.portal.zappyhire.com/",
 // BASE_URL: "https://feddev.zappyhire.com/",
  // PROFILE_URL: 'http://esf-candidatedetails.s3-website.ap-south-1.amazonaws.com/#zappyhire/access/'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
